import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Page from './components/Page'
import axios from "axios";
import SbEditable from 'storyblok-react'
// import TermHead from "./components/TermHead";
// import TermText from "./components/TermText";
// import TermWrap from "./components/TermWrap";
// NK3NQfYuIHRarFw11DZ1Rgtt
import StoryblokClient from 'storyblok-js-client'
const Storyblok = new StoryblokClient({
  accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
  cache: {
    clear: 'auto',
    type: 'memory'
  }
})
export default function TermsContainer(props) {
  // const [termsdata, setTermsData] = React.useState([])
  // useEffect(() => {
  //   axios.get("https://api.storyblok.com/v2/cdn/stories/terms?version=draft&token=mcPv7RQgbQXgCg4qKOCmEAtt&cv=1631254510").then((res) => {
  //     setTermsData(res.data?.story?.content?.data)
  //   })
  // }, [])
  return (
    <>
<SbEditable content={props.terms[0]}>

        <section className="center_container lg:pt-24 "
          style={{
            background: "#FFF",
          }}
        >
          <div className="container">
            <div className="row w-full resp-ters" style={{ margin: "auto" }}>
              <div
                className="about__text w-full  px-10 lg:px-20"
                style={{ paddingTop: 25 }}
              >
                <div>
                  <h1 className="text-center">
                    <span className="font-light ">
                    { props.allcomp && props.allcomp.title && props.allcomp.title }

                    </span>
                  </h1>
                  {/* <h3>For MusicArt minters</h3> */}
                </div>
                <div className="wrap-line">
</div>
                <div

              dangerouslySetInnerHTML={{__html: `${Storyblok.richTextResolver.render(props.terms[0] && props.terms[0].long_text)}`}}
              />
                {/* {
                  console.log("terms data", props )
                }
                 {props.terms.map((term,index) => {
                    return <Page term={term} key={index}/> 
                 })}  */}
                {/* {props.terms.map((term) => {
                console.log(terms , "this is terms in index")
                return (
                  <>
                  </>
                )
              })} */}

                {/* <div className="home__btns pb-8 pt-8">
                {isAgreed ? (
                  <a 
                  href={`/auth/register?isAgreed=${true}`}
                  className="terms__btn custom_link"
                  >
                    Continue sign Up
                  </a>
                ): (
                  <button
                  onClick={() => setIsAgreed(true)}
                    className="terms__btn custom_link"

                  >
                    I agree to the terms
                  </button>
                )}
              </div> */}
              </div>
            </div>
          </div>
        </section>
    
          </SbEditable>
    </>
  );
}
